"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppSettingsController = function () {
  /*@ngInject*/
  function AppSettingsController(Settings, Applications, settings, Modal) {
    _classCallCheck(this, AppSettingsController);

    this._Settings = Settings;
    this.settings = settings;
    this._Applications = Applications;
    this._Modal = Modal;
  }

  _createClass(AppSettingsController, [{
    key: "save",
    value: function save(setting) {
      var _this = this;

      this._Settings.save(setting).then(function (response) {
        console.log(response);
      }, function (err) {
        console.log(err);
        _this.error = err.data.message;
      });
    }
  }, {
    key: "assignIds",
    value: function assignIds(type) {
      var _this2 = this;

      this._Modal.confirmation("Are you sure you want to reset ALL the homeowner ids?!? This cannot be undone!!!!!!!!", "Reset ALL Homeowner ID").then(function () {
        _this2._Applications.assignIds({ override: true, type: type }).then(function (response) {
          console.log(response);
        }, function (err) {
          console.log(err);
          _this2.error = err.data.message;
        });
      });
    }
  }, {
    key: "sendAllIds",
    value: function sendAllIds() {
      var _this3 = this;

      this._Modal.confirmation("Are you sure you want to send all the homeowner IDs to the customer's emails??? THIS CANNOT BE STOPPED!!! MWAHAHAHAHAHA!!!", "Send All Homeowner Ids").then(function () {
        _this3._Applications.sendAllIds().then(function (response) {
          console.log(response);
        }, function (err) {
          console.log(err);
          _this3.error = err.data.message;
        });
      });
    }
  }]);

  return AppSettingsController;
}();

exports.default = AppSettingsController;


// WEBPACK FOOTER //
// ./client/app/admin/settings.controller.js